<template>
  <div id="head">
    <!-- 主题导航栏 -->
    <HeadNav :scroll="scroll"></HeadNav>
  </div>
</template>

<script>
import HeadNav from './HeadNav.vue'
export default {
  name: 'Head',
  components: { HeadNav },
  data() {
    return {
      lastScrollTop: '',
      scrollDirection: '',
      scroll: false
    }
  },
  watch: {
    '$store.state.common.pageName'(newVal) {
      this.name = newVal
      this.scroll = newVal == 'FundDetail'
    }
  },
  mounted() {
    this.name = this.$store.state.common.pageName
    this.scroll = this.name == 'FundDetail'
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      const y = document.documentElement.scrollTop || document.body.scrollTop
      // 首页交互不一样 特殊处理
      if (['Home', 'goPh', 'FundMarket','ESG'].includes(this.name)) {
        this.scroll = y > 0
      }

      // 判断滚动方向
      if (y > this.lastScrollTop) {
        // 向下滚
        this.scrollDirection = 'down'
      } else if (y < this.lastScrollTop) {
        // 向上滚
        this.scrollDirection = 'up'
      } else {
        // 没有滚动
        this.scrollDirection = 'none'
      }

      // 不同页面滚动交互区分
      if (this.scrollDirection == 'down' && y > 56) {
        this.$store.dispatch('toggleHeaderMenuExpansion', false)
      } else if (this.scrollDirection == 'up') {
        this.$store.dispatch('toggleHeaderMenuExpansion', true)
      }

      this.lastScrollTop = y
    }
  },
  beforeDestroy() {
    // 在组件销毁前移除滚动事件监听器
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
<style lang="scss" >
#head {
  width: 100%;
  height: 56px;
  position: fixed;
  top: 0;
  z-index: 3;
  transition: transform 0.3s;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/Head.vue